import { render, staticRenderFns } from "./DocumentsIcon.vue?vue&type=template&id=87df461c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87df461c')) {
      api.createRecord('87df461c', component.options)
    } else {
      api.reload('87df461c', component.options)
    }
    module.hot.accept("./DocumentsIcon.vue?vue&type=template&id=87df461c&", function () {
      api.rerender('87df461c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/DocumentsIcon.vue"
export default component.exports